const FORMULA_SHEET_PROGRAMS = ['WKAM', 'WKAMES']

export const isFormulaSheetProgram = (program?: string | null): boolean =>
  FORMULA_SHEET_PROGRAMS.includes(program?.toUpperCase() ?? '')
